import { render } from "./BountiesView.vue?vue&type=template&id=ba81187c&scoped=true&ts=true"
import script from "./BountiesView.vue?vue&type=script&lang=ts"
export * from "./BountiesView.vue?vue&type=script&lang=ts"

import "./BountiesView.vue?vue&type=style&index=0&id=ba81187c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba81187c"]])

export default __exports__